import { Avatar, Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import useProximasReservas from "core/features/reservas/hooks/useProximasReservas";
import React from "react";
import colors from "core/resources/theme/colors";
import { Empty } from "antd";
import moment from "moment";
import { ListagemReservaResponse } from "core/features/reservas/typings";
import {
  formatHorario,
  formatUnidadeBloco,
  getDefaultValuesForMessageModal,
  getIconForAreaComum,
  getTagColor,
} from "../util/helper";
import { AiFillMessage } from "react-icons/ai";
import { useMensagemModal } from "ui/components/DrawerNovaMensagem/MensagemModalContext";

function ProximasReservas() {
  const { data, isLoading, isFetching } = useProximasReservas();

  const _isLoading = isLoading || isFetching;

  if (_isLoading) {
    return (
      <Flex flexDir="column">
        <Title />
        <Skeleton h={"200px"} w={"100%"} mb={4} rounded={6} />
        <Skeleton h={"200px"} w={"100%"} mb={4} rounded={6} />
        <Skeleton h={"200px"} w={"100%"} mb={4} rounded={6} />
      </Flex>
    );
  }

  if (!_isLoading && !data?.items.length) {
    return (
      <>
        <Title />
        <Empty description="Não há próximos eventos" />
      </>
    );
  }

  return (
    <Flex flexDir="column">
      <Title />
      {data?.items.map((reserva, i) => (
        <React.Fragment key={reserva.id}>
          {i === 0 ||
          moment(data.items[i - 1].data).isBefore(
            moment(reserva.data),
            "day"
          ) ? (
            <TextDate text={moment(reserva.data).format("dddd, DD/MM/YYYY")} />
          ) : null}
          <CardReserva reserva={reserva} />
        </React.Fragment>
      ))}
    </Flex>
  );
}

const Title = () => (
  <Text fontSize={16} as="h3" fontWeight="700" color={colors.black}>
    Próximos Eventos
  </Text>
);

const TextDate = ({ text }: { text: string }) => (
  <Text fontSize={16} mb={4} textTransform="capitalize">
    {text}
  </Text>
);

export const CardReserva = ({
  reserva,
}: {
  reserva: ListagemReservaResponse;
}) => {
  const { openWithDefaultValues } = useMensagemModal();

  return (
    <Flex
      rounded={6}
      bg={getTagColor(reserva.status.id)}
      p={4}
      flexDir="column"
      color="white"
      mb={4}
    >
      <Flex gridGap={4} mb={2} alignItems="center">
        {getIconForAreaComum(reserva.areaComum.id, false, 32, colors.white)}
        <Flex flexDir="column" justifyContent="space-between" h="100%" ml={-2}>
          <Text fontSize={16} fontFamily="Montserrat" lineHeight="16px">
            Reserva do(a) {reserva.areaComum.nome}
          </Text>
          <Text fontSize={14} fontFamily="Montserrat" lineHeight="16px">
            {moment(reserva.data).format("DD/MM/YYYY")},{" "}
            {formatHorario(reserva.horaInicio, reserva.horaFim)}
          </Text>
        </Flex>
      </Flex>
      <Text mt={2} mb={3} fontSize={13}>
        Reserva feita por {reserva.nomeMorador}, unidade{" "}
        {formatUnidadeBloco(
          reserva.unidade.numero,
          reserva.unidade.blocoQuadra
        )}
        .
        {reserva.nomePessoaConfirmacao
          ? ` Confirmada por ${reserva.nomePessoaConfirmacao}`
          : ""}
      </Text>
      <Flex gridGap={4} alignItems="center">
        <Avatar
          bg={colors.primary}
          name={reserva.nomeMorador}
          src={reserva.fotoMorador}
          w="52px"
          h="52px"
          borderWidth={2}
          borderColor="white"
        />
        <Flex
          flexDir="column"
          justifyContent="space-between"
          h="100%"
          pt={2}
          flexGrow={1}
        >
          <Text fontSize={16} fontFamily="Montserrat">
            {reserva.nomeMorador}
          </Text>
          <Flex alignItems="center" justifyContent="space-between" w="100%">
            <Text fontSize={13} fontFamily="Montserrat" mr="auto">
              Unidade{" "}
              {formatUnidadeBloco(
                reserva.unidade.numero,
                reserva.unidade.blocoQuadra
              )}
            </Text>
            <AiFillMessage
              color="white"
              size={40}
              onClick={() =>
                openWithDefaultValues(getDefaultValuesForMessageModal(reserva))
              }
              cursor="pointer"
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ProximasReservas;
